import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HeartStraight, Lightbulb } from "@phosphor-icons/react";

export default function WellbeingImpactCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/calendar/wellbeing-impact").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.enough_data) return null;

  return (
    <div className="glass-card p-5 mt-5" data-testid="wellbeing-impact-card">
      <h3 className="text-sm font-semibold flex items-center gap-2 mb-1">
        <HeartStraight size={16} weight="duotone" className="text-[#ff6bd6]" /> Как календарь влияет на самочувствие
      </h3>
      <p className="text-xs text-muted-foreground mb-4">
        Показатели Whoop на утро после дней с разным числом встреч (за последние месяцы).
      </p>
      <div className="grid grid-cols-3 gap-3 mb-4">
        {data.buckets.map((b) => (
          <div key={b.label} className="rounded-lg border border-white/[0.07] bg-white/[0.03] p-3 text-center" data-testid={`impact-bucket-${b.label}`}>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1">{b.label} встреч</div>
            {b.n > 0 ? (
              <>
                <div className="font-heading text-xl font-bold num" style={{ color: b.recovery >= 67 ? "#00e676" : b.recovery >= 34 ? "#ffea00" : "#ff3b30" }}>
                  {b.recovery != null ? `${Math.round(b.recovery)}%` : "—"}
                </div>
                <div className="text-[10px] text-muted-foreground">восст. · HRV {b.hrv != null ? Math.round(b.hrv) : "—"} · сон {b.sleep != null ? Math.round(b.sleep) : "—"}%</div>
                <div className="text-[10px] text-muted-foreground/60 num mt-0.5">{b.n} дн.</div>
              </>
            ) : (
              <div className="text-xs text-muted-foreground py-2">мало данных</div>
            )}
          </div>
        ))}
      </div>
      <div className="space-y-1.5">
        {data.insights.map((t, i) => (
          <div key={i} className="flex items-start gap-2 text-xs text-muted-foreground" data-testid={`impact-insight-${i}`}>
            <Lightbulb size={13} className="text-[#ffea00] shrink-0 mt-0.5" />
            {t}
          </div>
        ))}
      </div>
    </div>
  );
}
